import React, { useEffect, useState,useRef } from "react";
import {
  Box,
  CircularProgress,
  Typography,
  Modal,
  Button,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../Utlis/Encryption";
import { BASE_URL } from "../../../components/BaseUrl";
import { useTranslation } from "react-i18next";

import DashboardCard from "../../../components/Cards/DashboardCard";

import total from "../../../assets/Absence/total.svg";
import paid from "../../../assets/Absence/paid.svg";
import unpaid from "../../../assets/Absence/unpaid.svg";
import affected from "../../../assets/Absence/affected.svg";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

const AbsenceSummary = () => {
  const { t } = useTranslation();
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;

  // Convert to local YYYY-MM-DD without timezone issues
  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const today = new Date();
  const defaultStart = formatLocalDate(
    new Date(today.getFullYear(), today.getMonth(), 1)
  );
  const defaultEnd = formatLocalDate(
    new Date(today.getFullYear(), today.getMonth() + 1, 0)
  );

  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [workerId, setWorkerId] = useState(null);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  // Modal State
  const [openFilter, setOpenFilter] = useState(false);
  const [tempStart, setTempStart] = useState(defaultStart);
  const [tempEnd, setTempEnd] = useState(defaultEnd);
  const [tempWorkerId, setTempWorkerId] = useState(null);

  const filterApplied = startDate !== defaultStart || endDate !== defaultEnd || workerId !== null;
const clearFilter = () => {
  setStartDate(defaultStart);
  setEndDate(defaultEnd);
  setWorkerId(null);
};

  const handleOpenFilter = () => {
    setTempStart(startDate);
    setTempEnd(endDate);
    setTempWorkerId(workerId);
    setOpenFilter(true);
  };
  const handleCloseFilter = () => setOpenFilter(false);

  const handleApplyFilter = () => {
    setStartDate(tempStart);
    setEndDate(tempEnd);
    setWorkerId(tempWorkerId);
    setOpenFilter(false);
  };

  // Fetch Summary API
  const fetchSummary = async () => {
    if (!decryptedToken) return;
    
    try {
      setLoading(true);

      let url = `${BASE_URL}/absences/admin/absences/summary?start_date=${startDate}&end_date=${endDate}`;
      if (workerId) {
        url += `&worker_id=${workerId}`;
      }

      console.log("📊 Fetching absence summary:", url);

      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
          "Content-Type": "application/json",
        },
      });

      const json = await res.json();
      console.log("📊 Absence Summary API Response:", json);
      console.log("📊 Full Response Structure:", JSON.stringify(json, null, 2));

      // Handle error: false/true format (API uses error: false, not status)
      if (!json.error && json.data?.summary) {
        const summaryData = json.data.summary;
        console.log("✅ Summary data extracted:", summaryData);
        console.log("✅ Total Absences:", summaryData.totalAbsences);
        console.log("✅ Total Days:", summaryData.totalDays);
        console.log("✅ By Type:", summaryData.byType);
        console.log("✅ By Worker:", summaryData.byWorker);
        console.log("✅ Average Per Worker:", summaryData.averagePerWorker);
        console.log("✅ Most Common Type:", summaryData.mostCommonType);
        console.log("✅ Most Absent Worker:", summaryData.mostAbsentWorker);
        setSummary(summaryData);
      } else {
        console.error("❌ API Error:", json.error || json.message || "Unknown error");
        setSummary(null);
      }
    } catch (err) {
      console.error("❌ Summary Fetch Error:", err);
      setSummary(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (decryptedToken) {
      fetchSummary();
    }
  }, [startDate, endDate, workerId, decryptedToken]);
  const startRef = useRef(null);
  const endRef = useRef(null);
  return (
    <Box sx={{ mt: 1, ml: 1, mr: 1 }}>
      
      {/* TOP BAR — Heading + Filter Icon + Loader */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        {/* LEFT — Heading + Loader */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 600,
              color: "#172B4D",
                 fontFamily: 'Poppins, sans-serif',
            }}
          >
            {t("absenceSummary")}
          </Typography>

          {loading && <CircularProgress size={18} />}
        </Box>

        {/* RIGHT — FILTER ICON */}
      {/* RIGHT — FILTER ICON */}
  {filterApplied ? (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 34,
        height: 34,
        borderRadius: 1,
        bgcolor: "#0C66E4",
        cursor: "pointer",
      }}
      onClick={() => setOpenFilter(true)}
    >
      {/* <FilterListIcon sx={{ color: "white", fontSize: 20 }} />
       */}
       <FilterAltIcon sx={{  color: "white", fontSize: 20  }} />

      {/* CLEAR FILTER BUTTON */}
      <Box
        onClick={(e) => {
          e.stopPropagation();
          clearFilter();
        }}
        sx={{
          position: "absolute",
          top: -6,
          right: -6,
          bgcolor: "white",
          width: 18,
          height: 18,
          borderRadius: "50%",
          border: "1px solid #C4C4C4",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          "&:hover": { bgcolor: "#f5f5f5" },
        }}
      >
        <Typography sx={{ fontSize: 12, color: "#333", fontWeight: "bold" }}>
          ×
        </Typography>
      </Box>
    </Box>
  ) : (
    <Box
      onClick={() => setOpenFilter(true)}
      sx={{
        border: "1px solid #C4C4C4",
        borderRadius: 1,
        width: 34,
        height: 34,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      <FilterListIcon sx={{ fontSize: 20 }} />
    </Box>
  )}
      </Box>

      {/* SUMMARY CARDS */}
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 5 }}>
          <CircularProgress size={40} />
        </Box>
      ) : summary ? (
        <Box>
          {/* Main Statistics Cards */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
              gap: "16px",
              mt: 2,
            }}
          >
            <DashboardCard
              icon={total}
              title={t("totalAbsences") || "Total Absences"}
              description={summary.totalAbsences ?? 0}
            />

            <DashboardCard
              icon={paid}
              title={t("paidAbsences") || "Paid Absences"}
              description={summary.paidAbsences ?? 0}
            />

            <DashboardCard
              icon={unpaid}
              title={t("unpaidAbsences") || "Unpaid Absences"}
              description={summary.unpaidAbsences ?? 0}
            />

            <DashboardCard
              icon={affected}
              title={t("totalDays") || "Total Days"}
              description={summary.totalDays ?? 0}
            />

            <DashboardCard
              icon={paid}
              title={t("paidDays") || "Paid Days"}
              description={summary.paidDays ?? 0}
            />

            <DashboardCard
              icon={unpaid}
              title={t("unpaidDays") || "Unpaid Days"}
              description={summary.unpaidDays ?? 0}
            />
          </Box>

          {/* All Absence Types as Individual Cards */}
          {summary.byType && typeof summary.byType === 'object' && (
            <Box sx={{ mt: 3 }}>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#172B4D",
                  fontFamily: "Poppins, sans-serif",
                  mb: 2,
                }}
              >
                {t("absenceByType") || "Absence by Type"}
              </Typography>
              
              {/* Calculate Total Leave (authorized absences) */}
              {(() => {
                const leaveTypes = ['VACATION', 'PERSONAL', 'MEDICAL', 'PAID_LEAVE', 'UNPAID_LEAVE', 'TRAINING'];
                const totalLeaveCount = leaveTypes.reduce((sum, type) => sum + (summary.byType[type]?.count || 0), 0);
                const totalLeaveDays = leaveTypes.reduce((sum, type) => sum + (summary.byType[type]?.days || 0), 0);
                
                // Type name mapping for display
                const typeNameMap = {
                  'VACATION': t("vacationLeave") || "Vacations Leave",
                  'PERSONAL': t("personalLeave") || "Personal Leave",
                  'MEDICAL': t("sickLeave") || "Sick Leave",
                  'UNJUSTIFIED': t("unjustifiedAbsence") || "Unjustified Absence",
                  'PAID_LEAVE': t("paidLeave") || "Paid Leave",
                  'UNPAID_LEAVE': t("unpaidLeave") || "Unpaid Leave",
                  'TRAINING': t("training") || "Training",
                  'OTHER': t("other") || "Other"
                };

                // Color mapping for each type
                const typeColorMap = {
                  'VACATION': { bg: '#E8F5E9', border: '#4BCE97', color: '#2E7D32' }, // green
                  'PERSONAL': { bg: '#E3F2FD', border: '#64B5F6', color: '#1565C0' }, // light blue
                  'MEDICAL': { bg: '#E1F5FE', border: '#03A9F4', color: '#0277BD' }, // blue
                  'UNJUSTIFIED': { bg: '#FFEBEE', border: '#EF5350', color: '#C62828' }, // red
                  'PAID_LEAVE': { bg: '#F3E5F5', border: '#BA68C8', color: '#7B1FA2' }, // lilac
                  'UNPAID_LEAVE': { bg: '#FCE4EC', border: '#EC407A', color: '#AD1457' }, // purple
                  'TRAINING': { bg: '#FFF9C4', border: '#FFD54F', color: '#F57F17' }, // yellow
                  'OTHER': { bg: '#F5F5F5', border: '#9E9E9E', color: '#424242' } // gray
                };

                return (
                  <Box>
                    {/* Total Leave Card */}
                    <Box sx={{ mb: 3 }}>
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
                          gap: "16px",
                        }}
                      >
                        <DashboardCard
                          icon={total}
                          title={t("totalLeave") || "Total Leave"}
                          description={`${totalLeaveCount} (${totalLeaveDays} ${t("days")} )`}
                          cardSx={{ minHeight: "100px", border: "2px solid #4BCE97" }}
                        />
                      </Box>
                    </Box>

                    {/* All Type Cards with Colors */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
                        gap: "16px",
                      }}
                    >
                      {Object.entries(summary.byType).map(([type, data]) => {
                        const colors = typeColorMap[type] || { bg: '#F5F5F5', border: '#9E9E9E', color: '#424242' };
                        return (
                          <DashboardCard
                            key={type}
                            icon={total}
                            title={typeNameMap[type] || type}
                            description={`${data?.count ?? 0} ${data?.count === 1 ? 'absence' : 'absences'} (${data?.days ?? 0} ${data?.days === 1 ? t("days") : t("day")}) - ${data?.percentage?.toFixed(1) ?? 0}%`}
                            cardSx={{ 
                              minHeight: "100px",
                              backgroundColor: colors.bg,
                              border: `2px solid ${colors.border} !important`,
                            }}
                            titleSx={{ color: colors.color, fontWeight: 600 }}
                          />
                        );
                      })}
                    </Box>
                  </Box>
                );
              })()}
            </Box>
          )}

          {/* Most Absent Worker */}
          {summary.mostAbsentWorker && (
            <Box sx={{ mt: 3 }}>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#172B4D",
                  fontFamily: "Poppins, sans-serif",
                  mb: 2,
                }}
              >
                {t("mostAbsentWorker") || "Most Absent Worker"}
              </Typography>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(1, 1fr)",
                  gap: "16px",
                  maxWidth: "400px",
                }}
              >
                <DashboardCard
                  icon={affected}
                  title={summary.mostAbsentWorker.workerName || "--"}
                  description={`${summary.mostAbsentWorker.totalAbsences || 0} absences`}
                />
              </Box>
            </Box>
          )}

          {/* Workers Statistics - Only show if there are workers */}
          {summary.byWorker && typeof summary.byWorker === 'object' && Object.keys(summary.byWorker).length > 0 && (
            <Box sx={{ mt: 3 }}>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#172B4D",
                  fontFamily: "Poppins, sans-serif",
                  mb: 2,
                }}
              >
                {t("absenceByWorker") || "Absence by Worker"}
              </Typography>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
                  gap: "16px",
                }}
              >
                {Object.entries(summary.byWorker).slice(0, 6).map(([workerId, data]) => (
                  <DashboardCard
                    key={workerId}
                    icon={total}
                    title={data?.workerName || `Worker ${workerId}`}
                    description={`${data?.totalAbsences ?? 0} absences (${data?.totalDays ?? 0} days)`}
                    cardSx={{ minHeight: "100px" }}
                  />
                ))}
              </Box>
            </Box>
          )}
        </Box>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 5 }}>
          <Typography sx={{ color: "#5E5C5C", fontFamily: "Poppins, sans-serif" }}>
            {t("noDataAvailable") || "No data available"}
          </Typography>
        </Box>
      )}

      {/* FILTER MODAL */}
      <Modal open={openFilter} onClose={handleCloseFilter}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 380,
            bgcolor: "white",
            borderRadius: 3,
            p: 3,
            boxShadow: 24,
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 600,
              mb: 2,
              color: "#172B4D",
                  fontFamily: 'Poppins, sans-serif',
            }}
          >
            {t("filterSummary")}
          </Typography>

          {/* Start Date */}
          <Box sx={{ mb: 2 }}>
            <label className="field_label">{t("startDate")}</label>
            <input
             ref={startRef}
                onClick={() => startRef.current?.showPicker()} 
              type="date"
              value={tempStart}
              onChange={(e) => setTempStart(e.target.value)}
              className="project_input"
              style={{ width: "100%", marginTop: "6px", height: "42px" }}
            />
          </Box>

          {/* End Date */}
          <Box sx={{ mb: 3 }}>
            <label className="field_label">{t("endDate")}</label>
            <input
             ref={endRef}
                onClick={() => endRef.current?.showPicker()} 
              type="date"
              value={tempEnd}
              onChange={(e) => setTempEnd(e.target.value)}
              className="project_input"
              style={{ width: "100%", marginTop: "6px", height: "42px" }}
            />
          </Box>

          {/* Buttons */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button variant="outlined" onClick={handleCloseFilter}>
              {t("cancel")}
            </Button>
            <Button variant="contained" onClick={handleApplyFilter}>
              {t("apply")}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default AbsenceSummary;
